<script>
import TwTitleBar from '../../components/TwTitleBar';

export default {
  components: {
    TwTitleBar,
  },
};
</script>

<template>
  <v-content class="page-not-found">
    <tw-title-bar title="Page not found"/>
  </v-content>
</template>



// WEBPACK FOOTER //
// src/pages/error-pages/PageNotFound.vue